<div class="container" fxFill>
Test
</div>
<div fxLayoutAlign="center center">
    <firebase-ui (signInSuccessWithAuthResult)="successCallback($event)" (signInFailure)="errorCallback($event)">
    </firebase-ui>
</div>